import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/logo.png'
import _imports_1 from '@/assets/images/东方明珠.png'
import _imports_2 from '@/assets/images/erweima.png'


const _hoisted_1 = { class: "whole-head" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"title-box\"><div><img src=\"" + _imports_0 + "\" alt><div class=\"title\"><div class=\"chinese\">上海市养老服务行业协会</div><div class=\"english\">Shanghai Senior Service Industry Association</div></div></div><img class=\"dfmz\" src=\"" + _imports_1 + "\" alt></div>", 1)
const _hoisted_3 = { class: "head-nav" }
const _hoisted_4 = { class: "nav-box" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "main-view" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"whole-bottom\"><div class=\"blue\"><div class=\"blue-box\"><img src=\"" + _imports_0 + "\" alt><div class=\"title-box\"><div class=\"chinese\">上海市养老服务行业协会</div><div class=\"english\">Shanghai Senior Service Industry Association</div></div><div class=\"text-box\"><div class=\"tel\">电话：021-53531001</div><div class=\"cz\">传真：021-53531001</div><div class=\"addr\">地址：上海市黄浦区盛泽路8号4楼</div></div><img src=\"" + _imports_2 + "\" alt></div></div><div class=\"black\"><span class=\"item\">沪ICP备11002366号</span><span class=\"item\">|</span><span class=\"item\">沪公网安备 31011202011519号</span><span class=\"item\">技术支持：友康科技</span></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.oneRouteList, (item) => {
            return (_openBlock(), _createElementBlock("span", {
              key: item.path,
              class: _normalizeClass(['nav-item', item.active?'active': '']),
              onClick: ($event: any) => (_ctx.clickTab(item))
            }, _toDisplayString(item.name), 11, _hoisted_5))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_router_view)
    ]),
    _hoisted_7,
    _createVNode(_component_Spinner)
  ], 64))
}